import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Spinner,
  Table,
  Button,
  Tabs,
  Tab,
} from "react-bootstrap";
import { MdOutlinePerson } from "react-icons/md";
import { AiFillGolden } from "react-icons/ai";
import { RiDeviceRecoverLine } from "react-icons/ri";
import API_DOMAIN from "../config/config";
import dayjs from "dayjs";
import "./tablecus.css";
import "bootstrap/dist/css/bootstrap.min.css";
import LoadingOverlay from "../components/LoadingOverlay";

const DashBoard = () => {
  const [userecoveryData, setUserrecoveryData] = useState([]);
 
  const [jewelpawnData, setUserjewlpawnData] = useState([]);
  const [customerData, setcustomerData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [interestData, setInterestData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [placeSearchTerm, setPlaceSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [loadingPawn, setLoadingPawn] = useState(true);
const [loadingRecovery, setLoadingRecovery] = useState(true);
const [loadingCustomer, setLoadingCustomer] = useState(true);
const [loadingInterest, setLoadingInterest] = useState(true);


  const parsePeriod = (period) => {
    let months = 0;
    let days = 0;

    if (!period) return { months, days };

    const monthMatch = period.match(/(\d+)\s*month(s)?/i);
    const dayMatch = period.match(/(\d+)\s*day(s)?/i);

    if (monthMatch) {
      months = parseInt(monthMatch[1], 10);
    }

    if (dayMatch) {
      days = parseInt(dayMatch[1], 10);
    }

    return { months, days };
  };

  // Format total months
  const formatPeriod = (totalMonths) => {
    const finalMonths = totalMonths;
    return `${finalMonths} month${finalMonths !== 1 ? "s" : ""}`;
  };

  // Aggregate interest data by receipt_no
  const aggregateInterestData = (interestData) => {
    console.log(interestData);
    const aggregated = interestData.reduce((acc, item) => {
      const receiptNo = item.receipt_no;
      if (!acc[receiptNo]) {
        acc[receiptNo] = {
          total_interest_income: 0,
          total_months: 0,
        };
      }
      acc[receiptNo].total_interest_income += parseFloat(
        item.interest_income || 0
      );
      console.log(item.interest_payment_periods);

      const { months } = parsePeriod(item.interest_payment_periods);
      acc[receiptNo].total_months += months;
      return acc;
    }, {});

    Object.keys(aggregated).forEach((receiptNo) => {
      const { total_months } = aggregated[receiptNo];
      aggregated[receiptNo].interest_payment_periods = formatPeriod(
        total_months
        // total_days
      );
    });

    return aggregated;
  };

  const fetchDatajewelpawncustomer = async () => {
   setLoadingCustomer(true);
    try {
      const response = await fetch(`${API_DOMAIN}/customer.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ search_text: "" }),
      });
      const responseData = await response.json();
      if (responseData.head.code === 200) {
        setcustomerData(responseData.body.customer);
         setLoadingCustomer(false);
      } else {
        throw new Error(responseData.head.msg);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setLoadingCustomer(false);
    }
  };

  const fetchDatarecovery = async () => {
    setLoadingRecovery(true);
    try {
      const response = await fetch(`${API_DOMAIN}/pawnrecovery.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ search_text: "" }),
      });
      const responseData = await response.json();
      if (responseData.head.code === 200) {
        let sortedData = responseData.body.pawn_recovery.map((user) => ({
          ...user,
          jewel_product: JSON.parse(user.jewel_product || "[]"),
        }));
        setUserrecoveryData(sortedData);
         setLoadingRecovery(false);
      } else {
        throw new Error(responseData.head.msg); 
       
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setLoadingRecovery(false);
    }
  };

  const fetchDatajewelpawn = async () => {
  setLoadingPawn(true);
  try {
    const response = await fetch(`${API_DOMAIN}/pawnjewelry.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ search_text: "" }),
    });
    const responseData = await response.json();
    if (responseData.head.code === 200) {
      const sortedData = responseData.body.pawnjewelry.map((user) => ({
        ...user,
        jewel_product: JSON.parse(user.jewel_product || "[]"),
      }));
      setUserjewlpawnData(sortedData);
      setUserData(sortedData);
        setFilteredData(sortedData);
          setLoadingPawn(false);
    } else {
      throw new Error(responseData.head.msg);
    }
  } catch (error) {
    console.error("Error fetching data:", error.message);
  } finally {
    setLoadingPawn(false);
  }
};


 

  const fetchinterestData = async () => {
    setLoadingInterest(true);
    try {
      const response = await fetch(`${API_DOMAIN}/interest.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ search_text: "" }),
      });
      const responseData = await response.json();
      
      if (responseData.head.code === 200) {
        setInterestData(responseData.body.interest);
        setLoadingInterest(false);
      } else {
        throw new Error(responseData.head.msg);
      }
    } catch (error) {
      setLoadingInterest(false);
      console.error("Error fetching data:", error.message);
    }
  };

  const handleSearch = () => {

    let filtered = userData;
    console.log("userData", userData);
    if (searchTerm || placeSearchTerm) {
      filtered = userData.filter((item) => {
        const matchesMobile = searchTerm
          ? item.mobile_number.toString().includes(searchTerm)
          : true;
        const matchesReceipt = searchTerm
          ? item.receipt_no.toString().includes(searchTerm)
          : true;
           const matchesCustomerno = searchTerm
          ? item.customer_no.toString().includes(searchTerm)
          : true;
     const matchesCustomerName = searchTerm
  ? (typeof item.name === "string"
      ? item.name.toLowerCase()
      : ""
    ).includes(searchTerm.toLowerCase())
  : true;
        const matchesPlace = placeSearchTerm
          ? (item.place || "")
              .toLowerCase()
              .includes(placeSearchTerm.toLowerCase())
          : true;
        return (
          (matchesMobile || matchesReceipt || matchesCustomerName || matchesCustomerno) &&
          matchesPlace
        );
      });
    }
    setFilteredData(filtered);
  };

  const handleClear = () => {
    setSearchTerm("");
    setPlaceSearchTerm("");
    setFilteredData(userData);
  };

  useEffect(() => {
    handleSearch();
  }, [searchTerm, placeSearchTerm, userData]);

  useEffect(() => {
    fetchDatajewelpawn();
    fetchDatarecovery();
    fetchDatajewelpawncustomer();
    fetchinterestData();
  }, []);

  const aggregatedInterestData = aggregateInterestData(interestData);

  const isPageLoading = loadingPawn || loadingRecovery || loadingCustomer || loadingInterest;

  return (
    <>
    <LoadingOverlay isLoading={isPageLoading} />
    <Container>
     
        <>
          <Row>
            <Col lg="3" md="6" xs="12" className="py-3">
              <div className="counter-card cyan">
                <span>
                  <MdOutlinePerson />
                </span>
                <span className="count-numbers plus bold">
                  {customerData.length}
                </span>
                <span className="count-name regular">Customer</span>
              </div>
            </Col>
            <Col lg="3" md="6" xs="12" className="py-3">
              <div className="counter-card blue">
                <span>
                  <AiFillGolden />
                </span>
                <span className="count-numbers plus bold">
                  {jewelpawnData.length}
                </span>
                <span className="count-name regular">Jewelry Pawn</span>
              </div>
            </Col>
            <Col lg="3" md="6" xs="12" className="py-3">
              <div className="counter-card green">
                <span>
                  <RiDeviceRecoverLine />
                </span>
                <span className="count-numbers plus bold">
                  {userecoveryData.length}
                </span>
                <span className="count-name regular">Jewelry Recovery</span>
              </div>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col lg="12">
              <h5 className="mb-3">Jewelry Pawn Details</h5>
              <Row className="mb-3">
                <Col lg="3" md="6" xs="12" className="mb-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Mobile number, pawn number or customer name"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </Col>
                <Col lg="3" md="6" xs="12" className="mb-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Place"
                    value={placeSearchTerm}
                    onChange={(e) => setPlaceSearchTerm(e.target.value)}
                  />
                </Col>
                <Col lg="3" md="6" xs="12">
                  <Button variant="secondary" onClick={handleClear}>
                    Clear
                  </Button>
                </Col>
              </Row>
              <div className="balance-table-wrapper">
      <Table bordered hover responsive className="table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Loan Number</th>
            <th>Customer Number</th>
            <th>Customer Name</th>
            <th>Location</th>
            <th>Mobile Number</th>
            <th>Principal Amount</th>
            <th>Interest Rate</th>
            <th>Jewelry Weight</th>
            <th>S/WGT Weight</th>
            <th>Total Weight</th>
            <th>Pawned Items</th>
            {/* <th>Jewelry Value (Pawned)</th> */}
            <th>Interest Outstanding</th>
            <th>Interest Paid</th>
            <th>Total Appraisal</th>
            {/* <th>Current Jewelry Value</th> */}
            {/* <th>alert</th> */}
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.length > 0 ? (
            filteredData.map((item) => (
              <tr key={item.id}>
                <td>{dayjs(item.pawnjewelry_date).format("DD-MM-YYYY")}</td>
                <td>{item.receipt_no}</td>
                <td>{item.customer_no}</td>
                <td>{item.name}</td>
                <td>{item.place}</td>
                <td>{item.mobile_number}</td>
                <td>{item.original_amount}</td>
                <td>{item.interest_rate}</td>
                <td>{item.jewel_weight}</td>
                <td>{item.net_weight}</td>
                <td>{item.total_weight}</td>
                <td>{item.pledged_items}</td>
                {/* <td>{(item.original_amount / item.total_weight).toFixed(2)}</td> */}
                <td>
                  <div className="dashboard">
                    <span>{item.interest_payment_period}</span>
                    <span style={{ color: "green" }}>
                      ₹{item.interest_payment_amount.toFixed(2)}
                    </span>
                  </div>
                </td>
                <td>
                  <div className="dashboard">
                    <span>
                      {aggregatedInterestData[item.receipt_no]
                        ?.interest_payment_periods || "N/A"}
                    </span>
                    <span style={{ color: "green" }}>
                      ₹
                      {aggregatedInterestData[
                        item.receipt_no
                      ]?.total_interest_income?.toFixed(2) || 0}
                    </span>
                  </div>
                </td>
                <td>
                  ₹
                  {(
                    parseFloat(item.original_amount || 0) +
                    parseFloat(item.interest_payment_amount || 0) 
                   
                  ).toFixed(2)}
                </td>
               
                <td style={{ textAlign: "center" }}>
                  <span
                    className={`badge ${
                      item.status === "நகை மீட்கபட்டது"
                        ? "bg-danger"
                        : "bg-success"
                    }`}
                    style={{
                      minWidth: "20px",
                      minHeight: "20px",
                      display: "inline-block",
                    }}
                  ></span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="17" className="text-center">
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
           
            </Col>
          </Row>
        </>
      
    </Container>
    </>
  );
};

export default DashBoard;
